import React from "react";
import { useNavigate } from "react-router-dom";
import { Phone } from "lucide-react";

const LocationSection = () => {
  const navigate = useNavigate();

  return (
    <>
      <section
        style={{ padding: "1rem 0", backgroundColor: "#f5f5f5" }}
      ></section>

      <section
        style={{
          padding: "2rem 0",
          background: "linear-gradient(135deg, #000000, #0ea5c6)",
          color: "white",
        }}
      >
        <div
          style={{
            maxWidth: "100%",
            margin: "0 auto",
            padding: "0 1rem",
          }}
        >
          <h2
            style={{
              fontSize: "2.5rem",
              fontWeight: "bold",
              textAlign: "center",
              marginBottom: "2rem",
            }}
          >
            Visit Us At
          </h2>

          <p style={{ textAlign: "center", marginBottom: "1rem" }}>
            Inside Kennedy Bowl
          </p>

          <p
            style={{
              textAlign: "center",
              marginBottom: "1.5rem",
              color: "#e0f2fe",
            }}
          >
            2300 Lawrence Ave E, Scarborough, ON M1P 2R3
          </p>

          <div
            style={{
              maxWidth: "520px",
              margin: "0 auto 1.75rem",
              padding: "1rem 1.25rem",
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              border: "1px solid rgba(255, 255, 255, 0.18)",
              borderRadius: "12px",
              textAlign: "center",
              backdropFilter: "blur(6px)",
            }}
          >
            <h3
              style={{
                fontSize: "1.25rem",
                fontWeight: "bold",
                marginBottom: "0.5rem",
                color: "#ffffff",
              }}
            >
              Summer Hours
            </h3>

            <p
              style={{
                marginBottom: "1rem",
                color: "#e0f2fe",
                lineHeight: 1.6,
              }}
            >
              By appointment only this summer.
            </p>

            <button
              style={{
                background: "linear-gradient(45deg, #0891b2, #22d3ee)",
                color: "white",
                padding: "0.9rem 2rem",
                border: "none",
                borderRadius: "8px",
                fontSize: "1rem",
                fontWeight: "bold",
                cursor: "pointer",
                transition: "all 0.3s ease",
                textTransform: "uppercase",
                letterSpacing: "1px",
                verticalAlign: "middle",
                boxShadow: "0 4px 14px rgba(0,0,0,0.25)",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "scale(1.05)";
                e.target.style.background =
                  "linear-gradient(45deg, #22d3ee, #0891b2)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "scale(1)";
                e.target.style.background =
                  "linear-gradient(45deg, #0891b2, #22d3ee)";
              }}
              onClick={() => navigate("/contact")}
            >
              Call to Schedule{" "}
              <Phone
                size={18}
                style={{
                  marginLeft: "0.2rem",
                  display: "inline",
                  verticalAlign: "middle",
                  paddingBottom: "2px",
                }}
              />
            </button>
          </div>

          <div
            style={{
              position: "relative",
              height: "250px",
              overflow: "hidden",
              borderRadius: "12px",
              boxShadow: "0 8px 30px rgba(15,23,42,0.6)",
              backgroundColor: "#020617",
            }}
          >
            <iframe
              title="900 Pro Shop Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2882.0641765725527!2d-79.27934542250257!3d43.750764071097855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d4d48f42a95b4d%3A0x51a6ed8f15c7b245!2s900%20Bowling%20Pro%20Shop!5e0!3m2!1sen!2sca!4v1772119298568!5m2!1sen!2sca"
              style={{
                border: 0,
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default LocationSection;
